/**
 * 施設質問リストから、顔認証・署名ステップの有効/必須フラグを導出する。
 *
 * バックエンド (FacilityQuestionController::getFacilityQuestions) は
 * whereVisibility(1) / whereVisibilityCompanion(1) と、選択中フィルタでの
 * 絞り込みをかけたうえで質問を返す。つまり無効な質問は「visibility=0 で返る」
 * のではなく、そもそもレスポンスに含まれない。
 *
 * そのため「リストに存在しない＝無効」として扱う必要がある。見つかった質問だけを
 * 反映すると、フィルタ切替時に前フィルタのフラグが Vuex に残り、無効なはずの
 * 顔認証・署名ステップへ遷移してしまう (Redmine #51392)。
 *
 * この関数は常に4つのフラグすべてを返し、呼び出し側が無条件に上書きできるようにする。
 *
 * @param {Array} questions facility-question/list のレスポンス配列
 * @returns {{
 *   enabledFaceCapture: boolean,
 *   requiredFaceCapture: boolean,
 *   enabledSignature: boolean,
 *   requiredSignature: boolean
 * }}
 */
export function deriveQuestionFlags(questions) {
  const list = Array.isArray(questions) ? questions : [];
  const findBySystemName = (systemName) =>
    list.find((question) => question && question.system_name == systemName);

  // visibility は API から数値(1/0)で返るため、既存実装と同じ緩い比較を維持する。
  const isVisible = (question) => Boolean(question) && question.visibility == true;
  const isRequired = (question) => isVisible(question) && question.required == true;

  const faceRecognition = findBySystemName('face_recognition');
  const signature = findBySystemName('signature');

  return {
    enabledFaceCapture: isVisible(faceRecognition),
    requiredFaceCapture: isRequired(faceRecognition),
    enabledSignature: isVisible(signature),
    requiredSignature: isRequired(signature),
  };
}
